import internoRoutes from "./internalRoutes/internoRoutes.js";
import bpoRoutes from "./internalRoutes/bpoRoutes.js";
import sandboxRoutes from "./internalRoutes/sandboxRoutes.js";
import usuarioRoutes from "./internalRoutes/usuarioRoutes.js";
import clienteRoutes from "./internalRoutes/clienteRoutes.js";
import mensagemRoutes from "./internalRoutes/mensagemRoutes.js";
import certificadoDigitalRoutes from "./internalRoutes/certificadoDigitalRoutes.js";
import notasFiscaisRoutes from "./internalRoutes/notasFiscaisRoutes.js";
import dashboardRoutes from "./internalRoutes/dashboardRoutes.js";
import recompensasRoutes from "./internalRoutes/recompensasRoutes.js";
import authRoutes from "./publicRoutes/authRoutes.js";
import discordRoutes from "./internalRoutes/discordRoutes.js";
import contasAPagarRoutes from "./internalRoutes/contasAPagarRoutes.js";
import cnaeRoutes from "./internalRoutes/cnaeRoutes.js";
import colaboradoresRoutes from "./internalRoutes/colaboradores.js";
import logosRoutes from "./internalRoutes/logosRoutes.js";
import timelineRoutes from "./internalRoutes/timelineRoutes.js";
import gestaoCobrancasRoutes from "./internalRoutes/gestaoCobrancasRoutes.js";
import centralAjudaLinksRoutes from "./internalRoutes/centralAjudaLinksRoutes.js";
import tiposRoutes from "./internalRoutes/tiposRoutes.js";
import invoicesRoutes from "./internalRoutes/invoicesRoutes.js";
import minhaEmpresaRoutes from "./internalRoutes/minhaEmpresa.js";
import faturamentoRoutes from "./internalRoutes/faturamentoRoutes.js";
import arquivosRoutes from "./internalRoutes/arquivosRoutes.js";

const internalRoutes = [
  ...internoRoutes,
  ...bpoRoutes,
  ...sandboxRoutes,
  ...usuarioRoutes,
  ...clienteRoutes,
  ...mensagemRoutes,
  ...certificadoDigitalRoutes,
  ...notasFiscaisRoutes,
  ...dashboardRoutes,
  ...recompensasRoutes,
  ...discordRoutes,
  ...contasAPagarRoutes,
  ...cnaeRoutes,
  ...colaboradoresRoutes,
  ...logosRoutes,
  ...timelineRoutes,
  ...gestaoCobrancasRoutes,
  ...centralAjudaLinksRoutes,
  ...tiposRoutes,
  ...invoicesRoutes,
  ...minhaEmpresaRoutes,
  ...faturamentoRoutes,
  ...arquivosRoutes,
];

const publicRoutes = [...authRoutes];

const completeRoutes = [...publicRoutes, ...internalRoutes];

export { publicRoutes, completeRoutes, internalRoutes };
